import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    //justifyContent: 'space-between',
    minHeight: '100%', 
    backgroundSize: 'cover',
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.65), rgba(35, 37, 41, 0.65)), url('/images/prices/backgroundPrices.svg')",  
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',  
  },
  backgrounplans: {
    height: '100%',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(2),    
  }, 
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
  },
  heroContentTitle: {
    fontWeight: 'bold',
    color: 'white',
    fontFamily: 'Century-Gothic',
    marginBottom: theme.spacing(4),
  },
  heroContentSubtitle: {
    color: 'white',
    fontFamily: 'Century-Gothic',
  }, 
  heroContentFooter: {
    marginBottom: theme.spacing(5),
  },
  cardShadow:{
    //minHeight: '100px',
    backgroundColor: 'transparent',
    borderRadius: '10px',
    boxShadow: '0px 0px 11px 2px rgba(0,0,0,0.12), 0px 0px 11px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
    '&:hover': {
      boxShadow: '0px 0px 10px 8px rgba(0,0,0,0.2), 0px 0px 10px 8px rgba(0,0,0,0.2)',
    },
  },
  cardContent:{
    backgroundColor: 'white',
  },
  cardHeader: {
    color: 'white',
    fontFamily: 'Century-Gothic',
    backgroundColor: '#33658A',
    align: 'center'
     
  },
  titlePlan:{
    //fontWeight: 'bold',
    color: 'white',
    fontFamily: 'Century-Gothic',
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(5),
    fontFamily: 'Century-Gothic',
    fontWeight: 'bold',
  },
  carddescription: {
    fontFamily: 'Century-Gothic',
    //fontWeight: 'bold',
  },
  bottomPrimary: {
    paddingBlockStart: '10px',
    paddingBlockEnd: '10px',
    paddingInlineStart: '20px',
    paddingInlineEnd: '20px',
    fontWeight: 'bold',
    background: '#33658A',
    color: 'white',
    fontFamily: 'Century-Gothic',
    '&:hover': {
      backgroundColor: '#33658A',
    },
  },
  bottomMargin: {
    backgroundColor: 'white',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  card: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  cardterm: {
    fontFamily: 'Century-Gothic',
    backgroundColor: 'white',
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    align: 'center',
    fontSize: 'small',
  },
  subContent: { 
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  tittle:{
    fontFamily: 'Century-Gothic',
  },
  subttext:{
    fontFamily: 'Century-Gothic',
    fontWeight: 'bold',
    color: '#fff',
  }
}));
export default useStyles;